import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import '../styles/pan.css'
import './App.css'

import InnerContent from './InnerContent'
import Store from '../Store'
import { GlobalContext } from '../contexts'
/**
 * We want to expose redux store from App-Framework. So if any other app wants to use it they can use with import store from App itself.
 * There are sometimes requirement that store needed when application wants to dispatch action without component
 * one use case in app-portal util/Service where we dispatch action for loading=true|false state in global redux store
 *
 */
let store

class App extends Component {
  getPreloadedState() {
    const preloadedState = {}
    if (typeof localStorage !== 'undefined' && localStorage.getItem('selectedAccount')) {
      preloadedState.selectedAccount = +localStorage.getItem('selectedAccount')
    }
    const { name, path, app_id } = this.props.appConfig.settings || {}
    if (name && path) {
      preloadedState.portalSettings = { name, path, app_id }
    }
    return preloadedState
  }
  render() {
    const preloadedState = this.getPreloadedState()
    store = Store(preloadedState, this.props.appConfig)
    return (
      <Provider store={store}>
        <Router>
          <GlobalContext.Provider value={GlobalContext.GLOBAL_CONTEXT}>
            <InnerContent
              appConfig={this.props.appConfig}
            />
          </GlobalContext.Provider>
        </Router>
      </Provider>
    )
  }
}

App.propTypes = {
  appConfig: PropTypes.object.isRequired
}
export { store }
export default App
